<p-table
  #dt
  [value]="setupParameters$ | async"
  dataKey="id"
  [resizableColumns]="true"
  [reorderableColumns]="false"
  columnResizeMode="expand"
  [styleClass]="'setup-parameter-table'"
  [lazy]="true"
>
  <ng-template pTemplate="header">
    <tr class="setup-parameter-table__header-row">
      <th
        *ngFor="let col of columns"
        [style.width]="col.width"
        [pSortableColumn]="col.field"
        [pSortableColumnDisabled]="!col.sortable"
        [pResizableColumnDisabled]="!col.resizable"
        [class]="col.styleClass"
        pResizableColumn
      >
        <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
        {{ col.header | translate }}
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-setupParameter let-rowIndex="rowIndex">
    <tr [formGroup]="formGroup.get('rows').get(rowIndex.toString())" class="setup-parameter-table__order-row">
      <td class="medium-cell">
        <ng-container *ngIf="editAll; else viewSetupParameterKindDescription">
          <input
            pInputText
            type="text"
            formControlName="description"
            (onBlur)="updateSetupParameter($event, setupParameter, SETUP_PARAMETER_COLUMN_TYPE.Name)"
            required
            class="inputtextbox"
            style="width: 100% !important;"
          />
        </ng-container>
        <ng-template #viewSetupParameterKindDescription>
          {{ setupParameter.description }}
        </ng-template>
      </td>
      <td class="medium-cell">
        <ng-container *ngIf="editAll; else viewExternalSetupParameterKindId">
          <input
            pInputText
            type="text"
            formControlName="externalSetupParameterKindId"
            (onBlur)="updateSetupParameter($event, setupParameter, SETUP_PARAMETER_COLUMN_TYPE.Description)"
            required
            class="inputtextbox"
          />
        </ng-container>
        <ng-template #viewExternalSetupParameterKindId>
          {{ setupParameter.externalSetupParameterKindId }}
        </ng-template>
      </td>
      <td class="tiny-cell">
        {{ setupParameter.externalWorkCenterId }}
      </td>
      <td class="tiny-cell">
        {{ setupParameter.setupParameterKindId }}
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td [colSpan]="columns.length">{{ 'APP.NO_DATA_FOUND' | translate }}</td>
    </tr>
  </ng-template>
</p-table>
